import styled from 'styled-components';
import { WxLabel, WxTitle } from '../components';
import { __ } from '../i18n/l10n';

export const NotFound = () => {
  return (
    <PageWrapper>
      <WxTitle title={'404'} align={'center'} size={'big'} darkMode />
      <WxLabel label={__('Nothing to see here')} />
    </PageWrapper>
  );
};

export const PageWrapper = styled.div<{ backgroundColor?: string }>`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  flex-direction: column;
  flex: 1;
  padding-bottom: 3.75rem;
`;
